import { type AreaId, type LocationId } from '../model'
import { type WithOptionalScheme, withScheme } from './util'

export const toCanvass = ({ includeScheme = false }: WithOptionalScheme = {}): string => {
  return withScheme('canvass', includeScheme)
}

export const toArea = ({ areaId, includeScheme = false }: WithOptionalScheme & { areaId: AreaId }): string => {
  return withScheme(`canvass/area/${encodeURIComponent(areaId)}`, includeScheme)
}

export const toLocation = ({
  locationId,
  includeScheme = false,
}: WithOptionalScheme & {
  locationId: LocationId
}): string => {
  return withScheme(`canvass/${encodeURIComponent(locationId)}`, includeScheme)
}

export const toCanvassVideo = ({ includeScheme = false }: WithOptionalScheme = {}): string => {
  return withScheme('canvass/video', includeScheme)
}

export const toCanvassFilters = ({ includeScheme = false }: WithOptionalScheme = {}): string => {
  return withScheme('canvass/filters', includeScheme)
}
